import * as React from 'react'
import shuffle from 'lodash-es/shuffle'

import { Site } from '@envato/foundation-types'

import { reportAutoSuggest } from '../../../../common/analytics/searchBarAnalytics'
import SeoHeadings from '../../../components/seoHeadings/seoHeadings'
import * as styles from './searchHeaderBlock.module.css'
import * as seoHeadingsStyles from '../../../components/seoHeadings/themes/homepage.newdesign.module.css'

import SearchLink from '../../../containers/searchLinkContainer'

import { config } from '../../../../common/config'

interface IProps {
  title?: string
  data: string[]
  currentSite: Site
}

const MAX_TERMS = 3

const SearchHeaderBlock: React.SFC<IProps> = ({
  title,
  children,
  data,
  currentSite
}) => {
  const terms = React.useMemo(() => shuffle(data).slice(0, MAX_TERMS), [data])

  const IMG_URL_DESKTOP = `${
    config.assets.PUBLIC_PATH
  }/images/home-page/new-design/${currentSite}/search-header-desktop-1588727016186.png`

  const IMG_URL_MOBILE = `${
    config.assets.PUBLIC_PATH
  }/images/home-page/new-design/${currentSite}/search-header-mobile-1588727016186.png`

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.autosuggestWrapper}>
          <div className={styles.seoHeader}>
            <SeoHeadings
              TagName="h1"
              heading={
                title || 'Discover thousands of web themes and templates'
              }
              subHeading=""
              styles={seoHeadingsStyles}
            />
          </div>

          {children}

          <div className={styles.searchTerms}>
            Try:
            {terms.map((term, i) => (
              <span key={i}>
                <SearchLink
                  className={styles.searchTermLink}
                  locationParams={{ term }}
                  onClick={() => reportAutoSuggest('Suggested terms')}
                >
                  {term}
                </SearchLink>
                {i < MAX_TERMS - 1 && ','}
              </span>
            ))}
          </div>
        </div>
        <div className={styles.imageWrapper}>
          <picture>
            <source srcSet={IMG_URL_DESKTOP} media="(min-width: 960px)" />
            <img
              src={IMG_URL_MOBILE}
              alt="image of item previews"
              className={styles.image}
            />
          </picture>
        </div>
      </div>
    </section>
  )
}

export default SearchHeaderBlock
